/* eslint-disable no-unreachable */
/* eslint-disable no-empty */

import drushim_lodash from 'lodash'
import SearchParams from '@/lib/enums/SearchParams'
import * as lib from '@/components/HomePageComponents/AutoComplete/lib'

export default {
  name: 'AutoSuggest',
  inheritAttrs: false,
  props: {
    submitByKey: {
      type: Boolean,
      required: false,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    searchProperties: {
      type: Object,
      required: false,
      default: () => { }
    },
    isRounded: {
      type: Boolean,
      required: false,
      default: false
    },
    employment: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    model: null,
    search: '',
    distanceModel: { Code: 3, NameInHebrew: '30 ק"מ' },
    distanceItems: [
      { Code: 1, NameInHebrew: '5 ק"מ' },
      { Code: 2, NameInHebrew: '10 ק"מ' },
      { Code: 7, NameInHebrew: '20 ק"מ' },
      { Code: 3, NameInHebrew: '30 ק"מ' },
      { Code: 4, NameInHebrew: '50 ק"מ' },
      { Code: 8, NameInHebrew: '70 ק"מ' },
      { Code: 5, NameInHebrew: '100 ק"מ' },
      { Code: 6, NameInHebrew: '150 ק"מ' }
    ],
    items: []
  }),

  computed: {
    displayedItems: {
      get() {
        return !drushim_lodash.isEmpty(this.items) ? this.items.slice(0, 6) : []
      },
      set(val) {
        this.model = val
      }
    },

  },

  mounted() {
    this.fetchPlaces = drushim_lodash.debounce(this.fetchPlaces, 200)
    this.applyPathGeolex()
    this.applyCurrDistanceRange()
  },

  watch: {
    searchProperties() {
      this.applyCurrDistanceRange()
      this.applyPathGeolex()
    }
  },
  methods: {
    /**
     * submit search by Enter key if model exists
     * @click on search-btn threw DOM to avoid emit events
     * TODO check behavior on mobile
     */
    submitByEnter() {
      if (this.model && this.submitByKey) {
        document.querySelector('.search-btn').click()
      } else {
        return false
      }
    },
    applyPathGeolex() {
      if (this.searchProperties && this.searchProperties.WhereFieldGeoLex) {
        this.model = {
          [SearchParams.STS.DisplayString]: this.searchProperties
            .WhereFieldText,
          [SearchParams.STS.SearchTypeIdentifier]: this.searchProperties
            .WhereFieldGeoLex,
          [SearchParams.STS
            .RegionIds]: this.searchProperties.WhereFieldAreasString.split(
              SearchParams.Constants.MultipleSeparator
            ).join(SearchParams.STS.RegionSeparator)
        }

        this.$emit('locationSelected', this.model)
      }
    },

    applyCurrDistanceRange() {
      if (this.searchProperties && Object.keys(this.searchProperties).length > 0) {
        this.distanceModel = this.searchProperties.Range
        this.$emit('distanceSelected', this.searchProperties.Range)
      } else {
        this.distanceModel = this.distanceItems[3]
        this.$emit('distanceSelected', this.distanceItems[3])
      }
    },

    async fetchPlaces(str) {
      if (!process.client) return // call only in client
      if (!drushim_lodash.isString(str) || !str.trim()) return // validate string
      if (this.model && str === this.model.displayString) {
        return
      }
      str = str.trim()

      try {
        if (this.model) {
          this.$emit('locationDeleted')
        }

        const data = {
          mainResultParameter: {
            max: 10
          },
          parameters: [
            { name: 'suggestPrefix', value: str },
            {
              name: 'suggestTypes',
              value: 'geo_multiple_city_id~en,geo_multiple_city_id~he'
            }
          ]
        }

        return await lib.loadSuggestions({ data }, this.$axios).then(res => {
          const { resultList } = res
          this.items = lib.getItems(resultList)
        })
      } catch (e) {
        console.log('fetchPlaces', e)
      }
    },

    onInput(entry) {
      this.$emit('locationSelected', entry)
    },

    onBlur() {
      if (!this.model) {
        this.search = ''
      }
    },

    distanceModelUpdate(entry) {
      this.distanceModel = entry
      this.$emit('distanceSelected', entry)
    }
  }
}
